module.exports = require("./xog.js");